module.exports = function (text) {
	return {
		id: 'analysis_tour',
		steps: [{
			target: '.analysis__preset',
			placement: 'bottom',
			title: text.presets,
			content: text.presetsInfo,
		}, {
			target: '.analysis__items-list',
			placement: 'right',
			responsive: [{
				width: 1054,
				placement: 'bottom'
			}],
			title: text.indicators,
			content: text.indicatorsInfo,
			onNext: function () {
				global.zebraAnalysis.selectItems([1, 2, 3]);
			}
		}, {
			target: '.analysis__chart-section .analysis__chart-area',
			placement: 'left',
			responsive: [{
				width: 1054,
				placement: 'top'
			}],
			title: text.diagram,
			content: text.diagramInfo,
			xOffset: 20
		}, {
			target: '.analysis__table',
			placement: 'top',
			title: text.data,
			content: text.dataInfo,
		}, {
			target: '.analysis__years-list',
			placement: 'top',
			title: text.years,
			content: text.yersInfo,
		}],
		onStart: function () {
			window.location.hash = 'analysis__section-0';
		}
	};
};



// WEBPACK FOOTER //
// ./temp/components/analysis/.variant/base/tourConfig.js